export default {
  dragOrClick: 'Presuňte súbor sem alebo kliknite na nahranie – maximálne {maxSize} | Presuňte súbory sem alebo kliknite na nahranie – maximálne {maxSize} na súbor',
  uploadError: 'Súbor nebol nahraný z dôvodu neplatného formátu alebo veľkosti: | Niektoré súbory neboli nahrané z dôvodu neplatného formátu alebo veľkosti:',
  dragError: {
    onDragTooManyFiles: 'Naraz je možné nahrať iba jeden súbor.',
    onDragSomeUnsupportedMimetype: 'Niektoré z vybraných súborov majú nepodporované formáty.',
    onDragAllUnsupportedMimetype: 'Žiadny z formátov súborov nie je podporovaný.',
    onDragUnsupportedMimetype: 'Formát súboru nie je podporovaný.',
  },
};
